import { readCookie, writeCookie } from '@/tools/tools';
/**
 * getters
 */
export var getters = {
  addresslist: function addresslist(state) {
    return state.classifylist;
  },
  smallImg: function smallImg(state) {
    return state.smallImg;
  }
};
/**
 * mutations
 */
export var mutations = {
  // 分类列表获取
  ADDCLASSIFYLIST: function ADDCLASSIFYLIST(state, payload) {
    state.classifylist = payload;
    writeCookie('classifylist', state.classifylist);
  },
  // 获取限时抢购小图标
  ADDSMALLIMG: function ADDSMALLIMG(state, payload) {
    state.smallImg = payload;
  }
};
/**
 * actions
 */
export var actions = {
  setclassifylist: function setclassifylist(_ref, payload) {
    var commit = _ref.commit;
    commit('ADDCLASSIFYLIST', payload);
  }
};
/**
 * state
 */
export var state = {
  classifylist: readCookie('classifylist') ? readCookie('classifylist') : [],
  smallImg: {}
};
var namespaced = true;
export var home = {
  namespaced: namespaced,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
};